import type { ReactNode } from "react";

import clsx from "clsx";
import { Button } from "react-aria-components";

import { ArrowDownIcon } from "../../icons/arrow-down";

import styles from "./collapsible.module.css";

export type CollapsibleTriggerProps = {
	children: ReactNode;
	isExpanded: boolean;
};

export function CollapsibleTrigger({ children, isExpanded }: CollapsibleTriggerProps): ReactNode {
	return (
		<Button className={clsx("body-2", styles.trigger)} slot="trigger">
			<ArrowDownIcon
				className={clsx(styles.triggerIcon, isExpanded && styles.triggerIconExpanded)}
			/>
			{children}
		</Button>
	);
}
